module.exports = __webpack_public_path__ + "html/more-text_dea0b98cd309ef9255989e2c98ee8175.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/more-text.html
// module id = d1XY
// module chunks = 151